module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=YE - Yemen.25e51660.svg";